<template>
  <div class="company">
    <!-- title -->
    <el-row>
      <el-col :span="24" :xs="24" class="company-title">
        {{ $t("companyInfo-title") }}</el-col
      >
    </el-row>
    <el-divider />
    <div class="company-content">
      <!-- 会社名（商号） -->
      <el-row>
        <el-col :span="12" :xs="12" style="font-weight: bold">
          {{ $t("companyInfo-name") }}</el-col
        >
        <el-col :span="12" :xs="12" class="">
          {{ companyInfo.companyName }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 本社＆拠点 -->
      <el-row>
        <el-col :span="12" :xs="12" style="font-weight: bold">
          {{ $t("companyInfo-headquarters-and-offices") }}</el-col
        >
        <el-col :span="12" :xs="12" class="">
          {{ companyInfo.headquartersAndOffices }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 海外オフィス -->
      <el-row>
        <el-col :span="12" :xs="12" style="font-weight: bold">
          {{ $t("companyInfo-overseas-offices") }}</el-col
        >
        <el-col :span="12" :xs="12" class="">
          {{ companyInfo.overseasOffices }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 決算期 -->
      <el-row>
        <el-col :span="12" :xs="12" style="font-weight: bold">
          {{ $t("companyInfo-fiscal-year") }}</el-col
        >
        <el-col :span="12" :xs="12" class="">
          {{ companyInfo.fiscalYear }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 事業内容 -->
      <el-row>
        <el-col :span="12" :xs="12" style="font-weight: bold">
          {{ $t("companyInfo-business-content") }}</el-col
        >
        <el-col :span="12" :xs="12" class="">
          {{ companyInfo.businessContent_ }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 所在地 -->
      <el-row>
        <el-col :span="12" :xs="12" style="font-weight: bold">
          {{ $t("companyInfo-address") }}</el-col
        >
        <el-col :span="12" :xs="12" class=""> {{ companyInfo.address }}</el-col>
      </el-row>
      <el-divider />
    </div>
    <div class="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3110.1245340436726!2d141.51003327593128!3d38.7837793717486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f88f1d7dca02e79%3A0x7fe1df2d8d117c44!2s162-1%20Motoyoshich%C5%8D%20Toyomazawa%2C%20Kesennuma%2C%20Miyagi%20988-0318!5e0!3m2!1szh-CN!2sjp!4v1739947948439!5m2!1szh-CN!2sjp"
        width="600"
        height="450"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        class="google-map"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { supabase } from '@/supabase.js'

export default {
  setup() {
    const { locale } = useI18n();
    // 主区域情报
    const companyInfo = ref({});

    const getCompanyInfo = async () => {
      const info = {
        companyName_ja: "株式会社盛栄国際",
        companyName_en: "Seiei International Corporation",
        headquartersAndOffices_ja: "仙台、大宮、名古屋、大阪、福岡",
        headquartersAndOffices_en: "Sendai, Omiya, Nagoya, Osaka, Fukuoka",
        overseasOffices_ja: "香港、カナダ ",
        overseasOffices_en: "Hong Kong ,  Canada",
        fiscalYear_ja: "3月31日",
        fiscalYear_en: "March 31 ",
        businessContent_ja: "自動車関連全般",
        businessContent_en: "Automobile-related businesses in general",
        address_ja: "xxxxxxxxxxx",
        address_en: "xxxxxxxxxxx",
      };
      const { data, error } = await supabase
        .from("company_info")
        .select("company_name_ja, company_name_en, headquarters_and_offices_ja, headquarters_and_offices_en, overseas_offices_ja,"
          + " overseas_offices_en, fiscal_year_ja, fiscal_year_en, business_content_ja, business_content_en, address_ja, address_en")
        .eq("id", "company_info")
        .single();
      if (error) {
        console.error("データ取得エラー:", error);
      } else {

        if (locale.value === "ja") {
          companyInfo.value.companyName = data.company_name_ja;
          companyInfo.value.headquartersAndOffices = data.headquarters_and_offices_ja;
          companyInfo.value.overseasOffices = data.overseas_offices_ja;
          companyInfo.value.fiscalYear = data.fiscal_year_ja;
          companyInfo.value.businessContent_ = data.business_content_ja;
          companyInfo.value.address = data.address_ja;
        } else {
          companyInfo.value.companyName = data.company_name_en;
          companyInfo.value.headquartersAndOffices = data.headquarters_and_offices_en;
          companyInfo.value.overseasOffices = data.overseas_offices_en;
          companyInfo.value.fiscalYear = data.fiscal_year_en;
          companyInfo.value.businessContent_ = data.business_content_en;
          companyInfo.value.address = data.address_en;
        }
      }
    };
    onMounted(() => {
      getCompanyInfo();
    });
    watch(locale, () => {
      getCompanyInfo();
    });
    return {
      companyInfo,
    };
  },
};
</script>

<style scoped>
.company {
  padding: 0 50px;
  background: white;
  height: 200%;
}

.company-title {
  text-align: left;
  font-size: 50px;
  padding: 30px;
  padding-top: 60px;
}

.company-content {
  padding: 0 60px;
}
.map-container {
  margin: 20px 0;
  text-align: center;
}

.google-map {
  border: none;
  border-radius: 8px;
  width: 100%;
  height: 450px;
}
@media (max-width: 768px) {
  .company {
    padding: 20px 20px 0px 20px;
    background: white;
    height: 120%;
  }
  .company-title {
    text-align: left;
    font-size: 30px;
    padding: 20px;
  }
  .company-content {
    padding: 0 20px;
  }
}
</style>
